// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3tKov","title":"Header_title__3KFte","left":"Header_left__3O7O1","clinicName":"Header_clinicName__3gebC"};